var map = {
	"./adult/nn/skrivehastighet-data.json": 641,
	"./adult/no/skrivehastighet-data.json": 642,
	"./youth/de/skrivehastighet-data.json": 643,
	"./youth/nn/skrivehastighet-data.json": 644,
	"./youth/no/skrivehastighet-data.json": 645,
	"./youth/se/skrivehastighet-data.json": 646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;